import style from './index.module.css';
import logo from '../../logo.png';

const Header = () => {
  return (
    <header className={style.header}>
      <img src={logo} alt="logo" className={style.logo} />
      <div className={style.textGroup}>
        <h1>One・Achieve</h1>
        <span>株式会社 ワン・アチーブ</span>
      </div>
    </header>
  );
}
export { Header };